{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://www.w3.org/ns/pub-schema/manifest/module/duration.schema.json",
  "title": "Duration",
  "type": "string",
  "pattern": "^P(?!$)((\\d+Y)|(\\d+\\.\\d+Y$))?((\\d+M)|(\\d+\\.\\d+M$))?((\\d+W)|(\\d+\\.\\d+W$))?((\\d+D)|(\\d+\\.\\d+D$))?(T(?=\\d)((\\d+H)|(\\d+\\.\\d+H$))?((\\d+M)|(\\d+\\.\\d+M$))?(\\d+(\\.\\d+)?S)?)??$"
}
